
    import createDonut from '@/mixins/createDonut.vue'
    import {
    MAP_SERVICES_SOURCE_ID,
    MAP_SERVICES_POLYGON_LAYER,
    MAP_SERVICES_CLUSTER_LAYER,
    MAP_SERVICES_CLUSTER_SYMBOL_LAYER,
    MAP_SERVICES_UNCLUSTER_LAYER,
    MAP_SERVICES_UNCLUSTER_ICON,
    CLUSTER_BLUE_COLOR
} from '@/data/variables'
    import {
    createMapClusterMarkersSource,
    createMapClustersLayer,
    createMapUnClustersLayer,
    createMapClusterCountsLayer,
    createMapCirclePolygons,
    createMapUnclusteredIconsOnSamePosition
} from '@/helpers/map'
    export default {
        mixins: [createDonut],
        data() {
            return {
                allMarkers: {},
                drawnMarkers: []
            }
        },
        watch: {
            getMarkersCollection: {
                deep: true,
                handler(newMarkersCollection, oldMarkersCollection) {
                    if(this.mapLoaded && oldMarkersCollection.length !== newMarkersCollection.length) {
                        this.createMarkers(newMarkersCollection)
                    }
                }
            }
        },
        computed: {
            getMarkersData() {
                return this.$store.getters.getEarthquakes
            },
            getMarkersCollection() {
                return this.getMarkersData.features
            },
        },
        methods: {
            addMarkersToMap() {
                const map = this.map;
                this.createMarkers(this.getMarkersCollection)
                if (map.getSource(MAP_SERVICES_SOURCE_ID)) {
                    map.removeLayer(MAP_SERVICES_CLUSTER_SYMBOL_LAYER);
                    map.removeLayer(MAP_SERVICES_CLUSTER_LAYER);
                    map.removeLayer(MAP_SERVICES_UNCLUSTER_LAYER);
                    map.removeLayer(MAP_SERVICES_POLYGON_LAYER);
                    map.removeLayer(MAP_SERVICES_UNCLUSTER_ICON);
                    map.removeSource(MAP_SERVICES_SOURCE_ID);
                }

                map.addSource(MAP_SERVICES_SOURCE_ID, createMapClusterMarkersSource(this.getMarkersData));
                map.addLayer(createMapClustersLayer(MAP_SERVICES_CLUSTER_LAYER, MAP_SERVICES_SOURCE_ID, CLUSTER_BLUE_COLOR));
                map.addLayer(createMapUnClustersLayer(MAP_SERVICES_UNCLUSTER_LAYER, MAP_SERVICES_SOURCE_ID));
                map.addLayer(createMapClusterCountsLayer(MAP_SERVICES_CLUSTER_SYMBOL_LAYER, MAP_SERVICES_SOURCE_ID));
                map.addLayer(createMapCirclePolygons(MAP_SERVICES_POLYGON_LAYER, MAP_SERVICES_SOURCE_ID));
                map.addLayer(createMapUnclusteredIconsOnSamePosition(MAP_SERVICES_UNCLUSTER_ICON, MAP_SERVICES_SOURCE_ID));

                this.redrawMarkers();
            },
            createMarkers(markers) {
                    this.allMarkers = markers.reduce((markersMap, props) => {
                        markersMap[props.properties.id] = props.properties.countOfSamePositions ? this.drawHidddenMarkersOnSamePosition(props) : this.drawDonuts(props);
                        return markersMap;
                    }, {});

            },
            drawHidddenMarkersOnSamePosition(feature) {
                let el = document.createElement('div');
                el.style.cursor = 'pointer';
                el.style.width = '50px';
                el.style.height = '50px';
                const marker = new mapboxgl.Marker(el)
                    .setLngLat(feature.geometry.coordinates)
                return marker;
            },
            drawDonuts(feature) {
                let el = this.createDonutFromCache(feature.properties);
                const marker = new mapboxgl.Marker(el)
                    .setLngLat(feature.geometry.coordinates)
                return marker;
            },
            onMapMoveEnd() {
                if (!this.map.getSource(MAP_SERVICES_SOURCE_ID) || !this.map.isSourceLoaded(MAP_SERVICES_SOURCE_ID)) {
                    return;
                }
                this.redrawMarkers();
                // this.map.once('idle', () => this.redrawMarkers());
            },
            redrawMarkers() {
                const unclusteredMarkers = this.getUnclusteredMarkers();

                const addedMarkers = unclusteredMarkers.filter(marker => !this.drawnMarkers.includes(marker));
                addedMarkers.forEach(marker => marker.addTo(this.map));

                const removedMarkers = this.drawnMarkers.filter(marker => !unclusteredMarkers.includes(marker));
                removedMarkers.forEach(marker => marker.remove());
                this.drawnMarkers = unclusteredMarkers

            },
            getUnclusteredMarkers() {
                let map = this.map;
                return [
                    ...map.querySourceFeatures(MAP_SERVICES_SOURCE_ID).reduce((servicesIds, feature) => {
                        const serviceId = feature.properties.id;
                        if (serviceId) {
                            servicesIds.add(serviceId);
                        }

                        return servicesIds;
                    }, new Set())
                ].map(serviceId => this.allMarkers[serviceId]);
            },
        },
    }
